import React from 'react'
import { connect } from 'react-redux'
import {
  change as changeFieldValue, formValueSelector, reduxForm
} from 'redux-form';
import adicionarDadosPagamentoEncomenda from '../../actions/encomenda/adicionarDadosPagamentoEncomenda';
import adicionarFormasPagamentoEncomenda from '../../actions/encomenda/adicionarFormasPagamentoEncomenda';
import { realParaNumber } from '../../util/numberUtil';
import { VALOR_POR_METRO_CUBICO } from './AbaPagamento';
import FormasPagamento from './FormasPagamento';
import NotasFiscais from './NotasFiscais';

export class AbaResumo extends React.Component {
  exibirItinerario () {
    const v = this.props.viagem;
    return (
      <div className="vx-enc-card-body">
        <div className="vx-enc-resumo-row">
          <span className="vx-enc-resumo-label">Empresa</span>
          <span className="vx-enc-resumo-value">{v.nomeEmpresa}</span>
        </div>
        <div className="vx-enc-resumo-row">
          <span className="vx-enc-resumo-label">Saída</span>
          <span className="vx-enc-resumo-value">{v.dataPartida} às {v.horaPartida}</span>
        </div>
        <div className="vx-enc-resumo-row">
          <span className="vx-enc-resumo-label">Chegada</span>
          <span className="vx-enc-resumo-value">{v.dataChegada} às {v.horaChegada}</span>
        </div>
        <div className="vx-enc-resumo-row">
          <span className="vx-enc-resumo-label">Embarque</span>
          <span className="vx-enc-resumo-value">{v.embarque}</span>
        </div>
        <div className="vx-enc-resumo-row">
          <span className="vx-enc-resumo-label">Veículo</span>
          <span className="vx-enc-resumo-value">{v.descricaoTipoVeiculo}</span>
        </div>
        {v.idItinerario && (
          <div className="vx-enc-resumo-row">
            <span className="vx-enc-resumo-label">Itinerário</span>
            <span className="vx-enc-resumo-value">{v.idItinerario}</span>
          </div>
        )}
      </div>
    );
  }

  exibirRemetenteDestinatario (endereco, pessoa, label, icon) {
    if (endereco && pessoa) {
      return (
        <div className="col-lg-6 col-12 mb-3">
          <div className="vx-enc-card" style={{ height: '100%' }}>
            <div className="vx-enc-card-header">
              <i className="material-icons">{icon}</i>
              <span className="vx-enc-card-title">{label}</span>
            </div>
            <div className="vx-enc-card-body">
              <div className="vx-enc-person-resumo-name">{pessoa.nome}</div>
              {pessoa.email && (
                <div className="vx-enc-person-resumo-detail">
                  <i className="material-icons">email</i>
                  {pessoa.email}
                </div>
              )}
              {pessoa.telefone && (
                <div className="vx-enc-person-resumo-detail">
                  <i className="material-icons">phone</i>
                  {pessoa.telefone}
                </div>
              )}
              <div className="vx-enc-person-resumo-address">
                <div>{`${endereco.logradouro}, ${endereco.numero ? endereco.numero : 'S/N'}${endereco.complemento ? `, ${endereco.complemento}` : ''}`}</div>
                <div>{`${endereco.bairro} - ${endereco.localidade} - ${endereco.uf}`}</div>
                <div>CEP: {endereco.cep}</div>
              </div>
            </div>
          </div>
        </div>
      )
    }
  }

  exibibirPagamento () {
    const pag = this.props.dadosPagamentoEncomenda;
    const valorTotal = this.props.recuperarValorTotal();
    const valorTotalGeral = this.props.recuperarValorTotalGeral();
    const valorSeguro = this.props.calcularValorSeguro();
    return (
      <div className="vx-enc-card-body" style={{ paddingTop: 0 }}>
        <div className="vx-enc-resumo-row">
          <span className="vx-enc-resumo-label">Produto</span>
          <span className="vx-enc-resumo-value">{pag.tipoProduto}</span>
        </div>
        <div className="vx-enc-resumo-row">
          <span className="vx-enc-resumo-label">Tipo de cálculo</span>
          <span className="vx-enc-resumo-value">{pag.tipoCalculo.label}</span>
        </div>
        {pag.tipoCalculo.value === 'VALOR_POR_KG' && (
          <div className="vx-enc-resumo-row">
            <span className="vx-enc-resumo-label">Peso</span>
            <span className="vx-enc-resumo-value">{pag.quantidadeKg} KG</span>
          </div>
        )}
        {pag.tipoCalculo.value === VALOR_POR_METRO_CUBICO && (
          <>
            <div className="vx-enc-resumo-row">
              <span className="vx-enc-resumo-label">Valor por m³</span>
              <span className="vx-enc-resumo-value">{realParaNumber(this.props.configuracaoEncomenda.precoMetroCubico || '0').toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</span>
            </div>
            <div className="vx-enc-resumo-row">
              <span className="vx-enc-resumo-label">Volume (etiquetas)</span>
              <span className="vx-enc-resumo-value">{pag.volume}</span>
            </div>
            <div className="vx-enc-resumo-row">
              <span className="vx-enc-resumo-label">Volume total</span>
              <span className="vx-enc-resumo-value">{pag.volumeM3 || '0,000'} m³</span>
            </div>
          </>
        )}
        <div className="vx-enc-resumo-row">
          <span className="vx-enc-resumo-label">Valor</span>
          <span className="vx-enc-resumo-value">{valorTotal.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</span>
        </div>
        {pag.habilitadoSeguro && (
          <>
            {pag.habilitadoValorDeclarado && (
              <div className="vx-enc-resumo-row">
                <span className="vx-enc-resumo-label">Valor declarado do produto</span>
                <span className="vx-enc-resumo-value">{pag.valorProduto.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</span>
              </div>
            )}
            {pag.habilitaValorNotaFiscal && (
              <div className="vx-enc-resumo-row">
                <span className="vx-enc-resumo-label">Valor nota fiscal</span>
                <span className="vx-enc-resumo-value">{pag.valorTotalNotaFiscal.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</span>
              </div>
            )}
            <div className="vx-enc-resumo-row">
              <span className="vx-enc-resumo-label">Valor Seguro</span>
              <span className="vx-enc-resumo-value">{valorSeguro.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</span>
            </div>
            <div className="vx-enc-resumo-row">
              <span className="vx-enc-resumo-label">Valor Total</span>
              <span className="vx-enc-resumo-value vx-orange">{valorTotalGeral.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</span>
            </div>
          </>
        )}
      </div>
    )
  }

  render () {
    const valorTotal = this.props.dadosPagamentoEncomenda.habilitadoSeguro
      ? this.props.recuperarValorTotalGeral()
      : this.props.recuperarValorTotal();

    return (
      <div className="vx-enc-flow">

        {/* Itinerário */}
        <div className="vx-enc-card">
          <div className="vx-enc-card-header">
            <i className="material-icons">directions_bus</i>
            <span className="vx-enc-card-title">Itinerário</span>
          </div>
          <div style={{ padding: 0 }}>
            {this.exibirItinerario()}
          </div>
        </div>

        {/* Remetente + Destinatário */}
        <div className="row">
          {this.exibirRemetenteDestinatario(this.props.enderecoRemetente, this.props.pessoaRemetente, 'Remetente', 'send')}
          {this.exibirRemetenteDestinatario(this.props.enderecoDestinatario, this.props.pessoaDestinatario, 'Destinatário', 'person_pin')}
        </div>

        {/* Pagamento */}
        <div className="vx-enc-card">
          <div className="vx-enc-card-header">
            <i className="material-icons">payments</i>
            <span className="vx-enc-card-title">Pagamento</span>
          </div>
          {this.exibibirPagamento()}
          <div style={{ padding: '0 20px 16px' }}>
            <FormasPagamento calcularValorSeguro={this.props.calcularValorSeguro} />
            <NotasFiscais notasFiscais={this.props.dadosPagamentoEncomenda.notasFiscais}/>
          </div>
          <div className="vx-enc-pay-total">
            <div className="vx-enc-pay-total-item">
              <span className="vx-enc-pay-total-label">Total a Pagar</span>
              <span className="vx-enc-pay-total-value">{valorTotal.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</span>
            </div>
          </div>
        </div>

        {/* Observação */}
        <div className="vx-enc-card">
          <div className="vx-enc-card-header">
            <i className="material-icons">notes</i>
            <span className="vx-enc-card-title">Observação</span>
          </div>
          <div className="vx-enc-card-body">
            <textarea
              rows='4'
              maxLength={255}
              name="observacao"
              onChange={e => this.props.adicionarDadosPagamentoEncomenda({ ...this.props.dadosPagamentoEncomenda, observacao: e.target.value })}
              className="form-control"
              placeholder="Observações sobre a encomenda (opcional)..."
            />
          </div>
        </div>

      </div>
    )
  }
}

const selector = formValueSelector('formularioCadastroEncomenda');

export const mapStateToProps = state => (
  {
    origem: state.origem,
    destino: state.destino,
    viagem: state.viagem,
    enderecoDestinatario: state.enderecoDestinatario,
    enderecoRemetente: state.enderecoRemetente,
    pessoaRemetente: state.pessoaRemetente,
    pessoaDestinatario: state.pessoaDestinatario,
    observacao: selector(state, 'observacao'),
    dadosPagamentoEncomenda: state.dadosPagamentoEncomenda,
    configuracaoEncomenda: state.configuracaoEncomenda,
    initialValues: {
      observacao: state.dadosPagamentoEncomenda.observacao
    }
  });


export default connect(mapStateToProps, {
  changeFieldValue,
  adicionarDadosPagamentoEncomenda,
  adicionarFormasPagamentoEncomenda
})(reduxForm({
  form: 'formularioCadastroEncomenda',
  enableReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(AbaResumo))
